export const CardtraderOauthConclude = (): JSX.Element => {
  return <></>
}
